import React from "react";
import { connect } from "react-redux";
import { setGlobalValue } from "../redux-actions/global-actions.js";
import audioManager from "./audio-manager";
import { getSiblingInArray } from "../helpers/get-sibling-in-array.js";
import {setAudioPreferenceInLocalstorage} from './audio-localstorage-operations.js'

class AudioControl extends React.Component {
  /* Listen for incoming prop to interact with the audioManager */
  componentWillUpdate(newProps) {
    if (newProps.audioMode === "full") {
      //Handle Audio is now ON
      audioManager.changeSongVolume("on");
    } else {
      //Handle Audio is now OFF
      audioManager.changeSongVolume("off");
    }
  }

  /* Toggle handle audio off */
  handleToggleClick() {
    //const audioModes = ["full", "sfx", "off"]; //TODO: Taking out SFX option to keep it simple
    const audioModes = ["full", "off"];
    const nextMode = getSiblingInArray(
      audioModes,
      audioModes.indexOf(this.props.audioMode),
      "next"
    );

    setGlobalValue({
      audioMode: nextMode
    });

    //Save this preference in localstorage
    setAudioPreferenceInLocalstorage(nextMode);

    //Don't allow browser to focus on this button
    this.refs.button.blur();
  }

  getButtonText() {
    if (this.props.audioMode === "full") {
      return "Audio On";
    }
    if (this.props.audioMode === "sfx") {
      return "SFX Only";
    }
    return "Audio Off";
  }

  render() {
    const style = {
      position: "absolute",
      zIndex: 2,
      right: 0,
      top: 0,
      outline: 0,
      background: "rgba(255,255,255,0.1)",
      border:0,
      // borderBottom: "2px solid rgba(0,0,0,0.3)",
      padding: 10,
      WebkitUserSelect: "none"
    };
    const buttonStyle = {
      display: "block",
      width:25,
      height:25,
      background:"url(/images/misc/audio-states.svg)",
      backgroundSize: "cover",
      backgroundPosition: this.props.audioMode === "full" ? "0% 0%" : "24px 0%"
    };

    return (
      <button
        className="pointer-on-hover"
        ref="button"
        tabIndex="-1"
        style={style}
        onClick={this.handleToggleClick.bind(this)}
      >
        <span style={buttonStyle}>

        </span>
        {/*{this.getButtonText()}*/}
      </button>
    );
  }
}

export default connect((state, props) => {
  return {
    audioMode: state.global.audioMode
  };
})(AudioControl);



// WEBPACK FOOTER //
// ./src/_audio/AudioControl.js